<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .input-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 570px;

    .dropdown-row {
      display: flex;
      align-items: center;
      background-color: colors.get(interfaceSwGrey_10);
      border-radius: utils.in_rem(10px);
      padding: utils.in_rem(2px);
    }

    .label {
      width: 240px;
      @include mixins.body2();
      padding: 0 utils.in_rem(14px);
    }

    color: colors.get(textBlack);
    @include mixins.body2();

    .select {
      width: utils.in_rem(300px);
    }
  }
</style>

<script>
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";
  import { integrationStore } from "../../stores";
  import InfoIcon from "./InfoIcon.svelte";

  export let type; // optional, required for typed sections
  export let setting; // the setting object to render

  // Compute available items for this type
  $: items =
    setting.values
      ?.filter(
        (item) =>
          !type ||
          !item.syncAsRestrictions ||
          item.syncAsRestrictions.includes(
            type.charAt(0).toUpperCase() + type.slice(1)
          )
      )
      .map((item) => ({
        value: String(item.val),
        id: String(item.val),
        label: item.key,
        icon: item.icon || "",
      })) ?? [];

  // Get selected items from store
  $: selectedItems = $integrationStore.getValue(setting.key, type).map(String);

  // Update store when selections change
  $: if (
    JSON.stringify($integrationStore.getValue(setting.key, type)) !==
    JSON.stringify(selectedItems)
  ) {
    $integrationStore.setValue(setting.key, selectedItems, type);
  }
</script>

<div class="input-compact">
  <div class="dropdown-row">
    <div class="label">
      <span>{setting.title}</span>

      <!-- This doesn't work? -->
      {#if setting.description}
        <Tooltip text={setting.description} />
      {/if}
    </div>
    <div class="select">
      {#key type}
        {#if items.length}
          <MultiSelectDropdown
            placeholder="Select"
            {items}
            style="width:300px;height:2.5rem;"
            bind:selectedItems
            restrictHeight
          />
        {:else}
          <Dropdown
            style="width:300px;height:2.5rem;"
            kind="input-field"
            size="large"
            disabled={true}
          >
            <span slot="tooltip">
              No filterable fields available for this type
            </span>
            <span slot="button"> Select </span>
          </Dropdown>
        {/if}
      {/key}
    </div>
  </div>

  {#if setting.info}
    <InfoIcon>{setting.info}</InfoIcon>
  {/if}
</div>
